<template>
    <app-modal-view @close="$emit('close')" class="shareModal">
        <template #header>
            <div class="header-project" v-if="unique">
                
                <div class="navbar-menu">
                    <div class="navbar-start">
                    <router-link :to="'/'" class="navbar-item is-marginless">
                        <img
                            src="@/assets/images/logo_eduloc360.png"
                            alt="eduloc360"
                            width="160"
                            height="50"
                        />
                    </router-link>
                </div>
                    <div class="navbar-end">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link is-arrowless">
                                <!--<span class="icon has-text-white"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                <span class="icon mr-1"><i class="mdi mdi-18px mdi-web"></i></span>
                                {{ $i18n.locale | localePrint }}
                            </a>
                            <div class="navbar-dropdown is-right">
                                <a
                                    v-for="locale in locales"
                                    :key="locale"
                                    @click="switchLocale(locale)"
                                    class="navbar-item has-text-black"
                                >
                                    {{ locale | localePrint }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header-project" v-else>
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <img
                                src="@/assets/images/logo_eduloc360.png"
                                alt="eduloc360"
                                width="160"
                                height="50"
                            />
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="navbar-item has-dropdown is-hoverable" v-if="isMultilang">
                            <a class="navbar-link is-arrowless mr-4" style="text-transform: capitalize; color:#FFFFFF;">
                                <!--<span class="icon"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                {{ langLabel(activeLang) }}
                            </a>

                            <div class="navbar-dropdown">
                                <a
                                    v-for="lang in languages"
                                    :key="lang"
                                    @click="activeLang = lang"
                                    class="navbar-item"
                                    style="text-transform: capitalize;"
                                >
                                    {{ langLabel(lang) }}
                                </a>
                            
                            </div>
                        </div>
                        <p
                            aria-label="close"
                            class="lb-modal-close has-text-white is-pulled-right"
                            @click="$emit('close')"
                        >
                            <span class="icon is-large">
                                <i class="mdi mdi-close mdi-24px"></i>
                            </span>
                        </p>
                    </div>
                    
                </div>
            </div>
        </template>
        <template #body>
            <div class="is-fullsize columns is-mobile">
                <div class="column pb-0">
                    <div class="icon-actions is-inline-block">
                        <figure class="image is-32x32 is-inline-block has-tooltip-right" :data-tooltip="$t('visualizations_number')">
                            <img src="@/assets/icons/vistas.svg" :alt="$t('visualizations_number')" >
                        </figure>
                        <span class="is-size-5">{{ project.views || 0 }}</span>
                    </div>
                    
                    <div class="icon-actions is-inline-block">
                        <figure class="image is-32x32 is-inline-block has-tooltip-right" :data-tooltip="$t('participants_number')">
                            <img src="@/assets/icons/participantes.svg" :alt="$t('participants_number')" >
                        </figure>
                        <span class="is-size-5">{{ project.participants || 0 }}</span>
                    </div>
                </div>
                <!--<div class="column pb-0 is-narrow pr-0">
                    <ShareNetwork
                        network="facebook"
                        :url="shareURLSocial"
                        :title="content.title"
                        :description="content.description"
                        hashtags="eduloc360"
                        class="social"
                    >
                        <font-awesome-icon :icon="['fab', 'square-facebook']" title="Facebook" class="is-size-2 pr-2" style="color:#0952A1;"/> 
                    </ShareNetwork>
                    <ShareNetwork
                        network="twitter"
                        :url="shareURLSocial"
                        :title="content.title"
                        hashtags="eduloc360"
                        class="social"
                    >
                        <font-awesome-icon :icon="['fab', 'square-x-twitter']" title="Twitter" class="is-size-2 px-2" style="color:#000000;"/> 
                    </ShareNetwork>
                    <ShareNetwork
                        network="whatsapp"
                        :url="shareURLSocial"
                        :title="content.title"
                        :description="content.description"
                        hashtags="eduloc360"
                        class="social"
                    >
                        <font-awesome-icon :icon="['fab', 'square-whatsapp']" title="WhatsApp" class="is-size-2 px-2" style="color:#27CF32;"/> 
                    </ShareNetwork>
                    <ShareNetwork
                        network="linkedin"
                        :url="shareURLSocial"
                        :title="content.title"
                        class="social"
                    >
                        <font-awesome-icon :icon="['fab', 'linkedin']" title="LinkedIn" class="is-size-2 px-2" style="color:#006493;"/>
                    </ShareNetwork>
                </div>-->
            </div>

            <div class="pb-4 columns" v-if="library && showViewButton">
                <div class="column pb-0">
                    <div class="columns is-vcentered pb-0">
                        <div class="column pb-0">
                            <p class="secondary-font-bold has-text-eduloc-red is-size-6">
                                {{ $t(`Constants.${project.format}`) }}
                            </p>
                            <p class="has-text-black is-size-5">
                                {{ getTitle }}
                            </p>
                    
                            
                            <!--<p class="has-text-black secondary-font">
                                {{ $t('project_creator_username') }} <span class="secondary-font-bold has-text-eduloc-red">{{ project.owner.username }} </span>
                            </p>-->
                        </div>
                        <div class="column pb-0 is-narrow">
                            <a class="button is-eduloc-red primary-font is-size-5 is-uppercase px-6" @click="viewProject(project)">{{ $t('Project.resume_action_access') }}</a>
                        </div>
                    </div>
                        <p class="pt-0 has-text-black secondary-font">
                            {{ getDescription }}
                        </p>

                    
                </div>
            </div>
            <div v-else>
                <p class="secondary-font-bold has-text-eduloc-red is-size-6">
                    {{ $t(`Constants.${project.format}`) }}
                </p>
                <p class="has-text-black is-size-5">
                    {{ getTitle }}
                </p>
                <!--<p class="has-text-black secondary-font">
                    {{ $t('project_creator_username') }} <span class="secondary-font-bold has-text-eduloc-red">{{ project.owner.username }} </span>
                </p>-->
                <p class="pt-2 has-text-black secondary-font">
                    {{ getDescription }}
                </p>
            </div>

            <div class="columns is-mobile" v-if="showLinks">
                <div class="column is-narrow has-text-centered" v-if="canShowQR">
                    <figure class="image is-square mt-2">
                        <vue-qrcode ref="qrcode" :value="qrInfo" :margin="0"/>
                    </figure>
                    <div v-if="!notGame && hasSessionApp" class="pt-2">
                        <p class="has-text-eduloc-red is-size-3 beton-font">{{ sessionCode }}</p>
                        <p class="has-text-black is-size-6">{{$t('project_session_code')}}</p>
                    </div>
                    <div v-if="notGame" class="pt-2">
                        <p class="has-text-eduloc-red is-size-3 beton-font">{{ project.shortCode }}</p>
                        <p class="has-text-black is-size-6">{{$t('project_short_code')}}</p>
                    </div>
                </div>
                <div class="column">
                    <div v-if="notGame && noPrivate">
                        <div class="">
                            <label v-t="'view_project_url'" class="label has-text-black"></label>
                            <div class="field has-addons shareUrl">
                                <p class="control is-expanded mb-0">
                                    <input :value="shareURL" readonly class="input is-6" type="text" />
                                </p>
                                <p class="control">
                                    <a
                                        :class="{
                                            'has-tooltip-active': showCopiedTooltipLink,
                                        }"
                                        :data-tooltip="
                                            $t(
                                                showCopiedTooltipLink
                                                    ? 'Sessions.url_copied'
                                                    : 'Sessions.copy_url'
                                            )
                                        "
                                        class="button is-disabled has-tooltip-left"
                                        @click="copyURLProject"
                                    >
                                        <span class="icon is-small">
                                            <i class="mdi mdi-18px mdi-content-copy"></i>
                                        </span>
                                    </a>
                                </p>
                                <p class="control" v-if="!library">
                                    <router-link
                                        v-t="'go_to_play'"
                                        :to="{
                                            name: 'project-view',
                                            params: { projectId: project._id },
                                        }"
                                        class="button is-eduloc-red"
                                        target="_blank"
                                        v-if="isMap"
                                    />
                                    <router-link
                                        v-t="'go_to_play'"
                                        :to="{
                                            name: 'project-view',
                                            params: { projectId: project._id },
                                        }"
                                        class="button is-eduloc-red"
                                        target="_blank"
                                        v-else
                                    />
                                </p>
                            </div>
                        </div>

                        <div class="pt-4" v-if="canShowEmbed">
                            <label v-t="'project_iframe'" class="label has-text-black"></label>
                            <div class="field has-addons shareIframe">
                                <div class="control is-expanded mb-0">
                                    <input :value="shareIframe" readonly class="input is-6" type="text" />
                                    
                                </div>
                                <div class="control">
                                    <a
                                        :class="{
                                            'has-tooltip-active': showCopiedTooltipIframe,
                                        }"
                                        :data-tooltip="
                                            $t(
                                                showCopiedTooltipIframe
                                                    ? 'Sessions.url_copied'
                                                    : 'Sessions.copy_url'
                                            )
                                        "
                                        class="button is-disabled has-tooltip-left"
                                        @click="copyIframe"
                                    >
                                        <span class="icon is-small">
                                            <i class="mdi mdi-18px mdi-content-copy"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="canShowQR">
                            <div class="">
                                <p class="has-text-black is-size-5 primary-font mb-2">{{$t('get_app')}}</p>
                            </div>
                            <div class="columns is-mobile mb-0">
                                <div class="column is-narrow">
                                    <figure class="image eduloc-logo">
                                        <img src="@/assets/images/eduloc360.png">
                                    </figure>
                                </div>
                                <div class="column">
                                    <div v-if="$i18n.locale=='ca-ES'">
                                        <img
                                            src="@/assets/images/google-play-badge_ca-ES.png"
                                            alt="googlePlay"
                                            width="150"
                                            class=""
                                        />
                                        <img
                                            src="@/assets/images/appstore_ca-ES.svg"
                                            alt="appStore"
                                            width="150"
                                            class=""
                                        />
                                    </div>
                                    <div v-else-if="$i18n.locale=='es'">
                                    
                                        <img
                                            src="@/assets/images/google-play-badge_es.png"
                                            alt="googlePlay"
                                            width="150"
                                            class=""
                                        />
                                    
                                        <img
                                            src="@/assets/images/appstore_es.svg"
                                            alt="appStore"
                                            width="150"
                                            class=""
                                        />
                                    
                                    </div>
                                    <div v-else>
                                        <img
                                            src="@/assets/images/google-play-badge_en.png"
                                            alt="googlePlay"
                                            width="150"
                                            class=""
                                        />
                                        <img
                                            src="@/assets/images/appstore_en.svg"
                                            alt="appStore"
                                            width="150"
                                            class=""
                                        />
                                    </div>
                                    
                                </div>
                                
                            </div>
                            <div class="pt-1">
                                <p class="has-text-grey-eduloc is-size-7 secondary-font is-italic">{{$t('google_attribution')}}</p>
                                <p class="has-text-grey-eduloc is-size-7 secondary-font is-italic">{{$t('apple_attribution')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </app-modal-view>
    
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { projectBackground } from '@/lib/helpers';
import { likeProject, highlightProject,fetchItem } from '@/services/API';
import _ from 'underscore';
import moment from 'moment';
import VueQrcode from 'vue-qrcode';
export default {
    components: {
        AppModalView,
        VueQrcode,
    },
    props: {
        content: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
        showNavigationButtons: {
            type: Boolean,
            default: true,
        },
        unique: {
            type: Boolean,
            default: false,
        },
        showViewButton: {
            type: Boolean,
            default: false,
        },
        library: {
            type: Boolean,
            default: false,
        },
        showLinks:{
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            project: this.content,
            sessionCode: "",
            showCopiedTooltipLink: false,
            showCopiedTooltipIframe: false,
            session: {},
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
            ownerPlan: {},
            baseURL: process.env.VUE_APP_WWW_URL,
            activeLang: this.content.langs && this.content.defaultLang ? this.content.defaultLang : this.content.langs && !this.content.defaultLang ? this.content.langs[0] : '',
        };
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    computed: {
        background() {
            return (bg) => {
                if(this.project.type=="treasurehunt"||this.project.type=="scape"||this.project.mode=="map"){
                    return projectBackground(
                        !_.isEmpty(this.project.image)
                            ? this.project.image
                            : !_.isEmpty(this.project.backgroundImage)
                            ? this.project.backgroundImage
                            : {'url':process.env.VUE_APP_ROOT_URL + '/img/project-default.png'}
                    );
                }
                return projectBackground(
                    !_.isEmpty(this.project.image)
                        ? this.project.image
                        : !_.isEmpty(this.project.backgroundImage)
                        ? this.project.backgroundImage
                        : bg
                );
            };
        },
        formattedCreationDate() {
            moment.locale(this.$i18n.locale);
            return moment(this.project.created).format('DD MMMM YYYY');
        },
        canEdit() {
            return this.project.accessLevel != 'read';
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        canHighlightProject() {
            return this.isAdmin && this.project.privacy == 'public';
        },
        hasSession(){
            return this.project.activeSession && this.sessionCode
        },
        hasSessionWeb(){
            return this.project.activeSession && this.sessionCode && (this.session.length &&  this.session.configuration.web==true);
        },
        hasSessionApp(){
            return this.project.activeSession && this.sessionCode && this.session.configuration.app==true;
        },
        shareSessionURL() {
            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                this.sessionCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
        notGame(){
            return this.project.type=='collection';
        },
        shareProjectURL(){
            /*if(this.project.mode && this.project.mode=='map'){
                return (
                    process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view'
                );

            }else{
                return (
                    process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id 
                );
            }*/
            return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view');
            
        },
        shareEmbedURL() {
            if(this.isMap || this.project.format=="PROJECT_TYPE_WALL"){
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view');
            }
            let url = process.env.VUE_APP_SHARE_EMBED_ROOT_URL;
            return url + this.project._id;
        },
        shareIframe() {
            return (
                '<iframe width="100%" height="600px" src="' +
                this.shareEmbedURL +
                '"></iframe>'
            );
        },
        isMap() {
            return this.project.format=="PROJECT_TYPE_MAP" || (this.notGame && this.project.type=='map')
        },
        shareURL(){
            if(this.isMap || this.project.format=="PROJECT_TYPE_WALL"){
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view');
            }else{
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id);
            }
            
        },
        shareURLSocial(){
            if(this.notGame){
                return this.shareURL;
            }
            return (process.env.VUE_APP_SOCIAL_SHARE_PROJECT_URL + this.project._id);
        },
        projectShortCode() {
            if(this.content.type!='trivial'){
                return this.content.shortCode
            }
        },
        canShowQR(){
            // console.log("can show qr?",this.notGame || this.hasSessionApp)
            return (this.notGame && this.appPublished) || (!this.notGame && this.hasSessionApp);
        },
        qrInfo(){
            if(this.hasSessionApp){
                // console.log("qr info",this.sessionCode)
                return encodeURI(this.baseURL + '/goapp.html?code=' + this.sessionCode);   
                // return this.sessionCode;
            }else{
                // console.log("qr info",this.content.shortCode)
                
                return encodeURI(this.baseURL + '/goapp.html?code=' + this.content.shortCode);
                // return this.content.shortCode;
            }
        },
        noPrivate(){
            return this.content.privacy!='private';
        },
        appPublished() {
            return this.content.appPublished;
        },
        canShowEmbed() {
            if (this.ownerPlan.configuration) {
                // console.log(this.ownerPlan.configuration)
                return this.ownerPlan.configuration.project.showEmbed;
            }
            
        },
        languages() {
            return this.content.langs;
        },
        isMultilang() {
            return this.content.langs && this.content.langs.length > 0;  
        },
        defaultLang() {
            return this.content.defaultLang;
        },
        getDescription() {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.content.defaultLang;
                // console.log("desc locale", locale)
                if (this.content.descriptionPerLang && this.content.descriptionPerLang[this.activeLang]) {
                    return this.content.descriptionPerLang[this.activeLang];
                }  else if (defaultLang && this.content.descriptionPerLang && this.content.descriptionPerLang[defaultLang]) {
                    // console.log("desc returning default")
                    return this.content.descriptionPerLang[defaultLang]
                } else if (this.content.descriptionPerLang && this.content.descriptionPerLang[locale]) {
                    // console.log("desc returning locale")
                    return this.content.descriptionPerLang[locale]
                }
                // console.log("no desc")
            } else {
                return this.content.description;
            }
        },
        getTitle() {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.content.defaultLang;
                // console.log("title locale", locale)
                if (this.content.titlePerLang && this.content.titlePerLang[this.activeLang]) {
                    return this.content.titlePerLang[this.activeLang];
                }  else if (defaultLang && this.content.titlePerLang && this.content.titlePerLang[defaultLang]) {
                    // console.log("title returning default")
                    return this.content.titlePerLang[defaultLang]
                } else if (this.content.titlePerLang && this.content.tiltePerLang[locale]) {
                    // console.log("title returning locale")
                    return this.content.titlePerLang[locale]
                }
                // console.log("no title")
            } else {
                return this.content.title;
            }
        }
    },
    methods: {
        isLangActive(locale){
            return this.$i18n.locale == locale;
        },
        
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
        async toggleLike() {
            if(this.$store.getters.isLoggedIn && !this.$store.getters.isAnonymous){
                let likeResult = await likeProject(this.project._id);
                this.project = likeResult.data;
            }
        },
        async toggleHomeFeatured() {
            if(this.$store.getters.isLoggedIn && !this.$store.getters.isAnonymous){
                let featuredResult = await highlightProject(this.project._id);
                this.project = featuredResult.data;
            }
        },
        copyURL() {
            this.$copyText(this.shareSessionURL).then((e) => {
                this.showCopiedTooltipLink = true;
                setTimeout(() => {
                    this.showCopiedTooltipLink = false;
                }, 1500);
            });
        },
        copyURLProject() {
            this.$copyText(this.shareProjectURL).then((e) => {
                this.showCopiedTooltipLink = true;
                setTimeout(() => {
                    this.showCopiedTooltipLink = false;
                }, 1500);
            });
        },
        copyIframe() {
            this.$copyText(this.shareIframe).then((e) => {
                this.showCopiedTooltipIframe = true;
                setTimeout(() => {
                    this.showCopiedTooltipIframe = false;
                }, 1500);
            });
        },
        viewProject(project){
            this.$emit('view',project);
        },
        langLabel(lang) {
            return this.$t("LANG_" + lang);
        },
    },
    async mounted() {
        if(this.project.activeSession){
            let sessionData = await fetchItem(
                'session',
                this.project.activeSession
            );
            this.session = sessionData.data;
            this.sessionCode = sessionData.data.shortCode;
        }

        if (this.$store.getters.isLoggedIn) {
            if (this.project.owner.school) {
                if (this.project.owner.school._id) {
                    
                } else {
                    let schoolPlan = await fetchItem(
                    'school',
                    this.project.owner.school
                    );
                this.ownerPlan = schoolPlan.data
                }
            }else if (this.project.owner.plan._id) {
                let ownerPlanDataPerId = await fetchItem(
                    'plan',
                    this.project.owner.plan._id
                );
                this.ownerPlan = ownerPlanDataPerId.data

            } else {
                let ownerPlanData = await fetchItem(
                    'plan',
                    this.project.owner.plan
                );
                this.ownerPlan = ownerPlanData.data

            }
        }
        
        

        //console.log(this.ownerPlan)

        
    },
};
</script>

<style scoped>
    @import '../assets/css/project-modal-share.css';
</style>
